import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SbApprovalBtn, SBSaveUpdateBtn } from "../Buttons/Buttons";
import customerImg from '../../assets/images/CustomerManagement/customer-img.svg'
import Select from 'react-select';
import { useEffect, useRef, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import DatePicker from "react-datepicker";
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import * as HeaderAuthentication from '../HeaderAuthentication'
import { loadCountryCodeDropdownData, loadCustomFieldsForUser, loadDepartmentDropdownData, loadReportingDesignationDropdownData, loadReportingToDropdownData, loadRolesDropdownData, loadUserReportingDesignationDropdownData, postDepartmentDatas, postUserManagementDatas } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Company_ID } from "../../Constants";
import CustomFieldsForUser from "./CustomFieldsForUser";

const options = [
    { label: "Functional Approval", value: "Functional Approval" },
    { label: "Financial Approval", value: "Financial Approval" },
    { label: "Complaints Approval", value: "Complaints Approval" },
    { label: "Escalation Approval", value: "Escalation Approval" },
    { label: "Leave Approval", value: "Leave Approval" },
];

const statusOptions = [
    { value: 16, label: "Active" },
    { value: 17, label: "Inactive" },
]

const approvalTypeOptionsOption = [
    { value: 1, label: "Level 1" },
    { value: 2, label: "Level 2" },
    { value: 3, label: "Level 3" },
    { value: 4, label: "Level 4" },
    { value: 5, label: "Level 5" },
]
const AddUserModal = (props) => {

    let dispatch = useDispatch();
    const userID = props.userID;
    const singleUserData = props.singleUserData;
    const customFields = props.customFields;
    const setCustomFields = props.setCustomFields;
    const userManagenemtData = props.userManagenemtData;
    const { departmentDropdown } = useSelector((state) => state.data);
    const { rolesDropdown } = useSelector((state) => state.data);
    const { reportingToDropdown } = useSelector((state) => state.data);
    const { getCountryCodeDropdownData } = useSelector((state) => state.data);
    const { reportingDesignationDropdown } = useSelector((state) => state.data);
    const { getUserReportingDesignationDropdown } = useSelector((state) => state.data);
    // const { getUserCustomFields } = useSelector((state) => state.data);

    const [userData, setUserData] = useState({
        File: "",
        FileName: "",
        IsFileUpdated: false, // Default value is false
        UserCode: "",
        CustomerID: Company_ID,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        EmailID: "",
        CountryCodeID: null,
        Phone: "",
        WorkAddress: "",
        ZipCode: "",
        DOB: "",
        SecondaryPhoneCountryCodeID: "",
        SecondaryPhone: "",
        DesignationID: "",
        DepartmentID: "",
        DOJ: "",
        TotalExperience: "",
        ProbationPeriod: "",
        ReportingToID: "",
        HomeAddress: "",
        StatusID: null,
        UserRoles: [
            // {
            //     RoleID: null
            // }
        ],
        UserApproval: [
            // {
            //     ApprovalLevel: "",
            //     LevelID: null
            // }
        ],
    });
    const [fromDate, setFromDate] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(statusOptions[0]);
    const [selectedApprovalTypes, setSelectedApprovalTypes] = useState([]);
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [errors, setErrors] = useState({});
    // const [customFields, setCustomFields] = useState([]);
    const [fieldValues, setFieldValues] = useState({});

    const handleSetApproval = () => {
        setShowApprovalModal(true);
    };

    const handleChange = (field, value) => {
        setUserData((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => ({ ...prev, [field]: null }));  // Clear error when user starts typing
    };

    // Handle the country code select change
    const handleChangeCountryCode = (selectedOption) => {
        handleChange("CountryCodeID", selectedOption.value);
    };

    // Handle emergency phone code select change
    const handleChangeEmergencyCode = (selectedOption) => {
        handleChange("SecondaryPhoneCountryCodeID", selectedOption.value);
    };

    // Handle the status select change
    const handleChangeStatus = (selectedOption) => {
        setSelectedStatus(selectedOption);
    };

    // Handle the date picker change for DOB, DOJ, etc.
    const handleDateChange = (field, date) => {
        handleChange(field, date);
    };

    const handleRoleChange = (selectedOptions) => {
        const updatedRoles = selectedOptions.map((option) => ({ RoleID: option.value }));
        handleChange("UserRoles", updatedRoles);

        // Clear errors for both RoleID and UserRoles when a selection is made
        setErrors((prev) => ({
            ...prev,
            RoleID: null,
            // UserRoles: null
        }));
    };

    const fileInputRef = useRef(null);

    const [selectedImg, setSelectedImg] = useState(null); // State for the selected image
    const [imgChange, setImgChange] = useState(false);

    const handleUploadClick = () => {
        fileInputRef.current.click(); // Trigger the file input click
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the file selected by the user
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                // The full base64 string includes the 'data:image/png;base64,' part
                const base64String = reader.result;

                // Get the filename from the file object
                const fileName = file.name;  // Get the file name

                // Set the fileName as prefix, so that it contains only the file name
                handleChange("FileName", fileName);  // Send the file name to your backend

                // Store the full base64 data in the File parameter (excluding the prefix)
                const base64Data = base64String.split(',')[1];  // Extract the actual base64 data part
                handleChange("File", base64Data);  // Save the base64 data in the File field

                // Update the state to display the image preview using full base64 string
                setSelectedImg(base64String);  // Display the image preview in the UI
                setImgChange(true);
            };
            reader.readAsDataURL(file);  // Convert the image to base64 format
        }
    };

    const handleApprovalLevelChange = (approvalTypeValue, selectedApprovalLevel) => {
        // Check if approvalTypeValue already exists in the userApproval array
        const updatedApprovalData = [...userData.UserApproval];
        const existingApprovalType = updatedApprovalData.find(
            (approval) => approval.ApprovalLevel === approvalTypeValue
        );

        if (existingApprovalType) {
            // If the approval type exists, update the LevelID
            existingApprovalType.LevelID = selectedApprovalLevel.value;
        } else {
            // If approval type doesn't exist, create a new entry
            updatedApprovalData.push({
                ApprovalLevel: approvalTypeValue,
                LevelID: selectedApprovalLevel.value,
            });
        }

        // Update the userData with the modified userApproval array
        setUserData((prevData) => ({
            ...prevData,
            UserApproval: updatedApprovalData,
        }));
    };

    const handleApprovalTypeChange = (selected) => {
        setSelectedApprovalTypes(selected);  // Always update selected list

        // Update `userData.UserApproval` by keeping only selected values
        setUserData(prev => ({
            ...prev,
            UserApproval: selected.map(option => ({
                ApprovalLevel: option.value,
                LevelID: prev.UserApproval.find(a => a.ApprovalLevel === option.value)?.LevelID || null
            }))
        }));
    };

    useEffect(() => {
        dispatch(loadDepartmentDropdownData());
        dispatch(loadRolesDropdownData());
        // dispatch(loadReportingToDropdownData());
        dispatch(loadCountryCodeDropdownData());
        // dispatch(loadReportingDesignationDropdownData());
        // dispatch(loadCustomFieldsForUser());
    }, [])

    // useEffect(() => {
    //     if (getUserCustomFields) {
    //         setCustomFields(getUserCustomFields);
    //     }
    // }, [getUserCustomFields]);

    useEffect(() => {
        if (userID && singleUserData && singleUserData.length > 0) {
            const user = singleUserData[0];  // Get the first user from the array
            setUserData({
                UserID: userID,
                FileName: user.FileName || '',
                FilePath: user.FilePath || '',
                IsFileUpdated: false,  // Default to false
                UserCode: user.UserCode || '',
                CustomerID: user.CustomerID || '',
                FirstName: user.FirstName || '',
                MiddleName: user.MiddleName || '',
                LastName: user.LastName || '',
                EmailID: user.EmailID || '',
                CountryCodeID: user.CountryCodeID || '',
                Phone: user.Phone || '',
                WorkAddress: user.WorkAddress || '',
                ZipCode: user.ZipCode || '',
                HomeAddress: user.HomeAddress || '',
                DOB: user.DOB ? moment(user.DOB).toDate() : '',
                SecondaryPhoneCountryCodeID: user.SecondaryPhoneCountryCodeID || '',
                SecondaryPhone: user.SecondaryPhone || '',
                DepartmentID: user.DepartmentID || '',
                DesignationID: user.DesignationID || '',
                DOJ: user.DOJ ? moment(user.DOJ).toDate() : '',
                TotalExperience: user.TotalExperience || '',
                ProbationPeriod: user.ProbationPeriod || '',
                ReportingToID: user.ReportingToID || '',
                StatusID: user.StatusID || '',
                UserRoles: Array.isArray(user.UserRoles) ? user.UserRoles : [],// Ensure UserRoles is an array
                UserApproval: Array.isArray(user.UserApproval) ? user.UserApproval : []
            });
            // Set the image if it exists
            if (user.FilePath) {
                setSelectedImg(user.FilePath);  // Use the FilePath from the API for the preview
            }
            // Set the selected approval types based on the UserApproval data
            const approvalTypes = user.UserApproval.map(approval => ({
                label: approval.ApprovalLevel,
                value: approval.ApprovalLevel,
                LevelID: approval.LevelID
            }));
            setSelectedApprovalTypes(approvalTypes);
            if (user.DepartmentID) {
                dispatch(loadReportingDesignationDropdownData(user.DepartmentID));
            }
            if (user.DesignationID) {
                dispatch(loadUserReportingDesignationDropdownData(user.DesignationID));
            }
        }
    }, [userID, singleUserData]);

    const isApprovalLevelSet = () => {
        // Check if for each selected approval type, a level is set
        return selectedApprovalTypes.every(option => {
            return userData.UserApproval.some(approval => approval.ApprovalLevel === option.value);
        });
    };

    const validateForm = () => {
        const requiredFields = [
            "FirstName", "LastName", "EmailID", "Phone", "WorkAddress", "ZipCode", "UserRoles"
        ];

        let newErrors = {};
        for (let field of requiredFields) {
            if (!userData[field] || (Array.isArray(userData[field]) && userData[field].length === 0)) {
                newErrors[field] = "This field is required.";
            }
        }

        // // Check if the image is uploaded if necessary
        // if (!userData.File) {
        //     newErrors.File = "Please upload an image.";
        // }

        // Check if approval type is selected
        // if (selectedApprovalTypes.length === 0) {
        //     newErrors.ApprovalTypes = "Approval Type is required.";
        // }

        // // Check if an approval level is set for selected approval types
        // if (selectedApprovalTypes.length > 0 && !isApprovalLevelSet()) {
        //     newErrors.ApprovalTypes = "Approval level must be set for the selected approval types.";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;  // Return false if there are errors
    };

    const AddUserManagementData = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;  // If validation fails, prevent form submission
        }

        const updatedUserData = { ...userData, IsFileUpdated: imgChange };
        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(updatedUserData),
        };
        dispatch(postUserManagementDatas(requestOption, props.handleClose, userManagenemtData, userID, imgChange, setImgChange, customFields));
        console.log(updatedUserData, 'updatedUserData')
    }

    return (
        <>
            <Modal show={props.open} onHide={props.handleClose} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{userID ? "Edit User" : "Add User"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col className='customer-form-fields-image-div'>
                            <img
                                // src={selectedImg || customerImg}
                                // src={selectedImg || (singleUserData && singleUserData[0] && singleUserData[0].FilePath) || customerImg}
                                src={
                                    selectedImg // Check if an image has been selected
                                        ? selectedImg // Display the selected image (base64 string or URL)
                                        : userData?.FilePath // Check if there is an image from the server
                                            ? userData?.FilePath.includes('http') // If it's a URL, display it
                                                ? userData?.FilePath // If it's a valid URL, display it
                                                : `data:image/png;base64,${userData?.FilePath}` // If it's base64, prepend the MIME type
                                            : customerImg // Fallback to customerImg if no selected image or server image
                                }
                                alt="" style={{ width: "100px", height: "100px", cursor: "pointer" }}
                                onClick={handleUploadClick}
                            />
                            <input type="file"
                                hidden
                                ref={fileInputRef}
                                onChange={handleFileChange}
                            />
                            <p>Upload Image</p>
                        </Col>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>First Name</label>
                                        <Form.Control
                                            type="text"
                                            value={userData.FirstName}
                                            onChange={(e) => handleChange("FirstName", e.target.value)}
                                            required
                                        />
                                    </div>
                                    {errors.FirstName && <div className="text-danger">{errors.FirstName}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Middle Name</label>
                                        <Form.Control
                                            type="text"
                                            value={userData.MiddleName}
                                            onChange={(e) => handleChange("MiddleName", e.target.value)}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Last Name</label>
                                        <Form.Control
                                            type="text"
                                            value={userData.LastName}
                                            onChange={(e) => handleChange("LastName", e.target.value)}
                                            required
                                        />
                                    </div>
                                    {errors.LastName && <div className="text-danger">{errors.LastName}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Email ID</label>
                                        <Form.Control
                                            type="email"
                                            value={userData.EmailID}
                                            onChange={(e) => handleChange("EmailID", e.target.value)}
                                            required
                                        />
                                    </div>
                                    {errors.EmailID && <div className="text-danger">{errors.EmailID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Contact Number</label>
                                        <div className='customer-contact-fields-div'>
                                            <Select
                                                // className='customer-contact-select '
                                                className="react-select-container customer-contact-select"
                                                classNamePrefix="react-select"
                                                value={getCountryCodeDropdownData?.find(option => option.value === userData.CountryCodeID)}
                                                onChange={handleChangeCountryCode}
                                                options={getCountryCodeDropdownData}
                                                placeholder="Select"
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            />
                                            <Form.Control
                                                type="tel"
                                                value={userData.Phone}
                                                onChange={(e) => handleChange("Phone", e.target.value)}
                                                required
                                            />
                                        </div>
                                        {errors.Phone && <div className="text-danger">{errors.Phone}</div>}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Work Address</label>
                                        <Form.Control
                                            type="text"
                                            value={userData.WorkAddress}
                                            onChange={(e) => handleChange("WorkAddress", e.target.value)}
                                            required
                                        />
                                    </div>
                                    {errors.WorkAddress && <div className="text-danger">{errors.WorkAddress}</div>}
                                </Col>

                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Zip Code</label>
                                        <Form.Control
                                            type="number"
                                            min="0"  // Prevents negative input
                                            value={userData.ZipCode}
                                            onChange={(e) => handleChange("ZipCode", e.target.value)}
                                            required
                                        />
                                    </div>
                                    {errors.ZipCode && <div className="text-danger">{errors.ZipCode}</div>}
                                </Col>
                                <Col md={4}>
                                    <div className='add-customer-calendar-container'>
                                        <label>Date of Birth</label>
                                        {/* <div className='add-customer-calendar-container'> */}
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd-MM-yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            // selectsRange
                                            placeholderText='DD/MM/YYYY'
                                            dropdownMode="select"
                                            selected={userData.DOB ? moment(userData.DOB, 'DD-MM-YYYY').toDate() : null} // Convert string to Date object
                                            onChange={(date) => handleDateChange("DOB", date)}
                                            maxDate={new Date()}
                                            required
                                        />
                                        <img src={calendar} alt="" />
                                        {/* </div> */}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Emergency Contact</label>
                                        <div className='customer-contact-fields-div'>
                                            <Select
                                                // className='customer-contact-select '
                                                className="react-select-container customer-contact-select"
                                                classNamePrefix="react-select"
                                                options={getCountryCodeDropdownData}
                                                value={getCountryCodeDropdownData?.find(option => option.value === userData.SecondaryPhoneCountryCodeID)}
                                                onChange={handleChangeEmergencyCode}
                                                placeholder="select"
                                                menuPosition="fixed"
                                                menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            />
                                            <Form.Control
                                                type="tel"
                                                value={userData.SecondaryPhone}
                                                onChange={(e) => handleChange("SecondaryPhone", e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </Col>

                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className='add-customer-calendar-container'>
                                        <label>Joining Date</label>
                                        {/* <div className='add-customer-calendar-container'> */}
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd-MM-yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            // selectsRange
                                            dropdownMode="select"
                                            placeholderText='DD/MM/YYYY'
                                            selected={userData.DOJ ? moment(userData.DOJ, 'DD-MM-YYYY').toDate() : null} // Convert string to Date object
                                            onChange={(date) => handleDateChange("DOJ", date)}
                                            maxDate={new Date()}
                                            required
                                        />
                                        <img src={calendar} alt="" />
                                        {/* </div> */}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Total Experience DOJ(Years)</label>
                                        <Form.Control
                                            type="number"
                                            min="0"  // Prevents negative input
                                            value={userData.TotalExperience}
                                            onChange={(e) => handleChange("TotalExperience", e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Probation Period (Months)</label>
                                        <Form.Control
                                            type="number"
                                            min="0"  // Prevents negative input
                                            value={userData.ProbationPeriod}
                                            onChange={(e) => handleChange("ProbationPeriod", e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Department</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={departmentDropdown}
                                            value={departmentDropdown?.find(option => option.value === userData.DepartmentID)}
                                            // onChange={(selectedOption) => handleChange("DepartmentID", selectedOption.value)}
                                            onChange={(selectedOption) => {
                                                handleChange("DepartmentID", selectedOption.value); // Update userData state with selected department ID

                                                // Fetch and update the reporting designations for the selected department
                                                dispatch(loadReportingDesignationDropdownData(selectedOption.value));
                                            }}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Job Title</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={reportingDesignationDropdown}
                                            value={reportingDesignationDropdown?.find(option => option.value === userData.DesignationID)}
                                            // onChange={(selectedOption) => handleChange("DesignationID", selectedOption.value)}
                                            onChange={(selectedOption) => {
                                                // Update the selected designation (e.g., job title and corresponding ReportingDesignationID)
                                                handleChange("DesignationID", selectedOption.value);  // Update userData state with selected ID

                                                // Call the API and pass the selected ReportingDesignationID to fetch related data
                                                dispatch(loadUserReportingDesignationDropdownData(Company_ID, selectedOption.ReportingDesignationID));
                                            }}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Role</label>
                                        <MultiSelect
                                            options={rolesDropdown || []}
                                            value={userData.UserRoles?.map(role =>
                                                rolesDropdown?.find(option => option.value === role.RoleID) || {} // Safe fallback to an empty object if not found
                                            ) || []}
                                            onChange={handleRoleChange}
                                            required
                                        />
                                    </div>
                                    {errors.UserRoles && <div className="text-danger">{errors.UserRoles}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Reporting To</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            value={getUserReportingDesignationDropdown?.find(option => option.value === userData.ReportingToID)}
                                            onChange={(selectedOption) => handleChange("ReportingToID", selectedOption.value)}
                                            options={getUserReportingDesignationDropdown}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            required
                                        />
                                    </div>
                                    {/* {errors.ReportingToID && <div className="text-danger">{errors.ReportingToID}</div>} */}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Home Address</label>
                                        <Form.Control
                                            type="text"
                                            value={userData.HomeAddress}
                                            onChange={(e) => handleChange("HomeAddress", e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Status</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            // value={selectedStatus}
                                            // onChange={handleChangeStatus}
                                            value={statusOptions?.find(option => option.value === userData.StatusID)}
                                            onChange={(selectedOption) => handleChange("StatusID", selectedOption.value)}
                                            options={statusOptions}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                            placeholder="Select"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8}>
                                    <label>Approval Type</label>
                                    <MultiSelect
                                        options={options}
                                        value={selectedApprovalTypes}
                                        onChange={handleApprovalTypeChange}
                                        // onChange={(selected) => {
                                        //     setSelectedApprovalTypes(selected);
                                        //     setErrors((prev) => ({ ...prev, ApprovalTypes: null }));  // Clear the error for ApprovalTypes
                                        // }}
                                        labelledBy="Select Approval Type(s)"
                                    />
                                    {/* Show error message if no approval type is selected */}
                                    {/* {errors.ApprovalTypes && (
                                        <div className="text-danger mt-2">
                                            {errors.ApprovalTypes}
                                        </div>
                                    )} */}
                                    {/* Show error message below Approval Type if no approval level is set */}
                                    {/* {selectedApprovalTypes.length > 0 && !isApprovalLevelSet() && (
                                        <div className="text-danger mt-2">
                                            Please set the approval level for the selected approval types.
                                        </div>
                                    )} */}
                                </Col>
                                <Col md={4} className="d-flex justify-content-start align-items-end">
                                    <SbApprovalBtn btnName="Set Approval" onClickEffect={handleSetApproval} />
                                </Col>
                            </Row>
                            <CustomFieldsForUser
                                customFields={customFields}
                                fieldValues={fieldValues}  // Ensure fieldValues are properly passed
                                setFieldValues={setFieldValues}  // Ensure this setter updates the correct state
                                setCustomFields={setCustomFields}  // If you need to update custom fields dynamically
                            // setCustomeLocalImage={setCustomeLocalImage}  // If you are handling image uploads locally
                            />
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleClose} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddUserManagementData} />
                </Modal.Footer>
            </Modal >

            <Modal show={showApprovalModal} onHide={() => setShowApprovalModal(false)} className="add-user-submodal">
                <Modal.Header closeButton>
                    <Modal.Title>Set Approval</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedApprovalTypes.map(option => (
                        <div key={option.value} className="approval-option mb-3">
                            <label>{option.label} Level</label>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                // placeholder={option.label}
                                // options={approvalTypeOptionsOption}
                                placeholder={`${option.label} Level`}
                                options={approvalTypeOptionsOption}
                                value={approvalTypeOptionsOption.find(
                                    (opt) => opt.value === userData.UserApproval.find(
                                        (approval) => approval.ApprovalLevel === option.label
                                    )?.LevelID
                                )}
                                onChange={(selectedApprovalLevel) => handleApprovalLevelChange(option.value, selectedApprovalLevel)}
                            />
                        </div>
                    ))}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddUserModal;